<template>
  <div class="privacyGame">
      <!-- style="color: red;" -->     
         <p><b>与第三方共享个人信息清单</b>

 </p><p>   为保障我们的产品相关功能的实现及安全稳定运行，产品中部分服务会由第三方提供，我们需要在您使用对应功能时向第三方共享您的个人信息，包括通过软件工具开发包（SDK）或其他类似的应用程序的方式。我们将在本清单中披露目前我们的产品中包含的第三方服务商，并说明我们与该第三方服务商共享个人信息的基本情况，如果您未使用相关功能，我们将不会与该第三方服务商共享您的个人信息。您还可以通过第三方服务商的隐私政策或者官方网站链接查看其收集使用个人信息的规则，第三方服务商可能由于版本或功能升级原因改变其个人信息收集处理规则，请以其公示的官方说明为准。

 </p><p><b>● 三方SDK名称：移动智能终端补充设备标识体系统一调用SDK</b>
 </p><p><b>功能类型：匿名设备标识符</b>
 </p><p><b>第三方主体：中国信息通信研究院</b>
 </p><p><b>收集/共享方式：通过SDK收集、不共享数据（com.bun.miitmdid）</b>
 </p><p><b>使用目的和场景：提供移动智能终端补充设备标识体系；获取移动安全联盟广告标识符，用于标识设备</b>
 </p><p><b>权限调用 ：不涉及</b>
 </p><p><b>处理方式：采用去标识化、加密传输的安全处理方式</b>
 </p><p><b>涉及个人信息类型：网络状态；联网方式；设备信息：OAID、VAID、AAID；应用安装列表。</b>
 </p><p>隐私政策链接：https://www.msa-alliance.cn/col.jsp?id=122
 </p><p>官网链接：https://www.msa-alliance.cn/
 </p><p>补充说明：oaidSDK的Android端包含com.netease相关包名的类(com.netease.nis.sdkwrapper.Utils)，但是并未使用网易相关服务。项目内包括SDK中有且仅有上述一个类与com.netease相关。SDK其它名称（移动安全联盟oaid sdk、MSA移动安全联盟SDK）

 </p><p>● 三方SDK名称：鲸鸿动能SDK
 </p><p>功能类型：游戏内广告播放、展示
 </p><p>第三方主体：华为软件技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：程序化广告投放、广告监测归因与反作弊
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息（广告标识符（OAID）、设备标识符（IMEI、Android ID）、设备品牌、型号、传感器信息、系统基本信息（操作系统信息））、网络信息（网络信息（运营商）、网络连接状态）、位置信息（大致位置信息（WLAN信息、蓝牙信息））、应用信息（应用基本信息、应用安装列表）、广告交互行为（广告互动记录，曝光、点击、转化信息）。
 </p><p>隐私政策链接：https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582
 </p><p>官网链接：https://developer.huawei.com/consumer/cn/
 </p><p>补充说明：为MSA移动安全联盟SDK内嵌SDK

 </p><p>● 三方SDK名称：中广协CAID（iOS）
 </p><p>功能类型：匿名设备标识符
 </p><p>第三方主体：中国广告协会
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：标识用户
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：网络状态；CAID。
 </p><p>官网链接：http://www.china-caa.org/

 </p><p>● 三方SDK名称：微信 OpenSDK Android（微信开放平台SDK）
 </p><p>功能类型：登录与分享
 </p><p>第三方主体：深圳市腾讯计算机系统有限公司
 </p><p>收集/共享方式：通过SDK收集（内嵌腾讯分享sdk）
 </p><p>使用目的和场景：用于微信账号登录游戏、帮助用户分享内容至微信客户端
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息：IMEI、IDFA、Android ID、IMSI、MAC、OAID；应用安装列表、网络状态。
 </p><p>隐私政策链接：https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
 </p><p>官网链接：https://open.weixin.qq.com

 </p><p>● 三方SDK名称：QQ SDK（QQ开放平台SDK）
 </p><p>功能类型：登录与分享
 </p><p>第三方主体：深圳市腾讯计算机系统有限公司
 </p><p>收集/共享方式：通过SDK收集（内嵌腾讯分享sdk）
 </p><p>使用目的和场景：用于QQ账号登录游戏、帮助用户分享内容至QQ客户端
 </p><p>权限调用 ：存储（媒体和文件）权限
 </p><p>权限使用目的：支持QQ账号绑定和分享功能
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息：IMEI、IDFA、Android ID、IMSI、MAC、OAID；SD卡根目录、网络状态、应用安装列表。
 </p><p>隐私政策链接：https://privacy.qq.com/policy/tencent-privacypolicy
 </p><p>官网链接：https://open.tencent.com/

 </p><p>● 三方SDK名称：QQ互联sdk（Android版本）
 </p><p>功能类型：登录与分享
 </p><p>第三方主体：深圳市腾讯计算机系统有限公司
 </p><p>收集/共享方式：通过SDK收集（内嵌腾讯分享sdk）
 </p><p>使用目的和场景：用于QQ账号服务、帮助用户分享内容至QQ客户端
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息（系统名称/系统版本/设备型号）、应用列表、相册权限、存储权限、网络状态、SD卡根目录。
 </p><p>隐私政策链接：https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e
 </p><p>官网链接：https://connect.qq.com/index.html

 </p><p>● 三方SDK名称：微博SDK（微博开放平台SDK）
 </p><p>功能类型：分享
 </p><p>第三方主体：北京微梦创科网络技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用户分享内容至微博客户端
 </p><p>权限调用 ：存储（媒体和文件）权限
 </p><p>权限使用目的：支持微博分享功能
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息：IMEI、IDFA、IDFV、Android ID、IMSI、MAC、OAID；网络状态；BSSID(WIFI的MAC地址)。
 </p><p>隐私政策链接：https://open.weibo.com/development/mobile
 </p><p>官网链接：https://open.weibo.com/

 </p><p>● 三方SDK名称：华为广告
 </p><p>功能类型：广告
 </p><p>第三方主体：华为技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：华为广告数据监测、上报
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型： 设备及使用信息：操作系统的设置信息、网络信息、连接类型、运营商信息、华为帐号信息；此外，每日会采集一次设备的应用软件安装列表。位置信息：在向您展示广告时，会采集设备位置信息，收集该信息是为了向您提供与地理位置相关的广告。
 </p><p>隐私政策链接：https://developer.huawei.com/consumer/cn/policy-center/
 </p><p>官网链接：https://developer.huawei.com/consumer/cn/

 </p><p>● 三方SDK名称：OPPO联盟广告SDK
 </p><p>功能类型：广告
 </p><p>第三方主体：OPPO广东移动通信有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：OPPO广告数据监测、上报
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：网路身份识别信息（IP地址）、已安装应用列表、软件版本号、软件签名、软件包名、设备连接信息（电信运营商、网络环境）、设备属性信息（设备型号、操作系统版本、设备地理位置、IMEI、MAC地址、OpenID、设备SN码）
 </p><p>隐私政策链接：https://u.oppomobile.com/main/privacy.html
 </p><p>官网链接：https://u.oppomobile.com/

 </p><p>● 三方SDK名称：VIVO广告
 </p><p>功能类型：广告
 </p><p>第三方主体：广东天宸网络科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：VIVO广告数据监测、上报
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：网路身份识别信息（IP地址）、已安装应用列表、软件版本号、软件签名、软件包名、设备连接信息（电信运营商、网络环境）、设备属性信息（设备型号、操作系统版本、设备地理位置、IMEI、MAC地址、OpenID、设备SN码）
 </p><p>隐私政策链接：https://dev.vivo.com.cn/openAbility/adSense
 </p><p>官网链接：https://dev.vivo.com.cn/?from=header

 </p><p>● 三方SDK名称：小米广告
 </p><p>功能类型：广告
 </p><p>第三方主体：北京小米移动软件有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：小米广告数据监测、上报
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息：IMEI/（在Android Q上的）OAID、设备型号、操作系统版本、设备传感器信息（手机角速度、手机加速度）、IP地址，用以判断当前的注册、登录环境是否安全。
 </p><p>隐私政策链接：https://dev.mi.com/console/
 </p><p>官网链接：https://dev.mi.com/platform

 </p><p>● 三方SDK名称：米盟广告（仅安卓）
 </p><p>功能类型：广告
 </p><p>第三方主体：深圳小米信息技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：广告投放及广告监测归因、反作弊、广告投放统计
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识符（IMEI、OAID、AAID、UDID、VAID、Android ID、MAC地址、IMSI），设备基础信息（设备型号、操作系统、IP地址、屏幕宽高、屏幕密度、Android版本号、SDK版本、MIUI版本号、 MIUI版本名称、系统语言、UserAgent、手机地区、国家编码 、国家名称）。
 </p><p>隐私政策链接：https://dev.mi.com/console/doc/detail?pId=2630
 </p><p>官网链接：https://dev.mi.com/platform

 </p><p>● 三方SDK名称：UC信息流广告
 </p><p>功能类型：广告监测
 </p><p>第三方主体：广州市动景计算机科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：广告投放及数据监测、上报
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：获取联网权限、获取WIFI网络信息状态、获取设备标识IMEI、 检测当前网络状态、读/写外部存储。
 </p><p>隐私政策链接：https://yingxiao.uc.cn/article_207.html
 </p><p>官网链接：https://yingxiao.uc.cn/

 </p><p>● 三方SDK名称：快手联盟（Android）
 </p><p>功能类型：广告监测
 </p><p>第三方主体：北京快手科技有限公司
 </p><p>收集/共享方式：通过SDK收集；内嵌（com.vivask.sdk、com.kwad.sdk、com.egrows.sdk组件）
 </p><p>使用目的和场景：广告投放及数据监测、上报、商业化广告统计
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：获取OAID、当前已连接上的WIFI信息、运营商信息、应用列表信息、传感器（设备传感器-重力传感器，IP设备传感器-加速度传感器，设备传感器-陀螺仪传感器）、应用安装列表、手机运营商、IP地址；获取联网权限、 获取MAC地址 、SD卡根目录、Android ID、检测当前网络状态 、 获取设备标识IMEI、手机CPU。
 </p><p>隐私政策链接：https://u.kuaishou.com/home/detail/1290
 </p><p>官网链接：https://ad.e.kuaishou.com/

 </p><p>● 三方SDK名称：优量汇 Android SDK
 </p><p>功能类型：广告
 </p><p>第三方主体：深圳市腾讯计算机系统有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：广告，为用户提供多渠道的信息展示（为广点通内嵌SDK）
 </p><p>权限调用 ：存储（媒体和文件）权限
 </p><p>权限使用目的：广告信息追踪时使用
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：获取运营商、AndroidID、当前已连接上的wifi信息、BSSID、读写文件、动态注册广播、创建文件夹、设备传感器、应用列表信息、应用安装列表、SD卡根目录、IP地址。
 </p><p>隐私政策链接：https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983
 </p><p>官网链接：https://e.qq.com/dev/index.html

 </p><p>● 三方SDK名称：穿山甲广告SDK-Android
 </p><p>功能类型：广告
 </p><p>第三方主体：北京巨量引擎网络技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：广告，为用户提供多渠道的信息展示
 </p><p>权限调用 ：无
 </p><p>权限使用目的：向最终用户投放广告时使用
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识符（IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial，iOS(IDFV、IDFA)），设备MAC地址，SD卡根目录，应用安装列表，IP地址，WLAN接入点（SSID、BSSID），精确位置信息、粗略位置信息，设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器），设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息、CPU信息、可用存储空间大小、手机系统重启时间、磁盘总空间、系统总内存空间、运营商信息、Wi-Fi状态、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态。
 </p><p>隐私政策链接：https://www.csjplatform.com/privacy
 </p><p>官网链接：https://www.csjplatform.com/

 </p><p>● 三方SDK名称：Unity3D插件
 </p><p>功能类型：3D动画
 </p><p>第三方主体：Unity Technologies
 </p><p>收集/共享方式：调用系统相关接口自动采集
 </p><p>使用目的和场景：基础unity动画功能；app展示3d人物形象时，仅本地使用
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：网络状态、读取手机状态和身份、监听手机状态(否处于通话)、AndroidID、获取移动网络运营商名字、获取运行中进程信息权限、获取应用列表信息；传感器信息。
 </p><p>隐私政策链接：https://unity3d.com/legal/privacy-policy
 </p><p>官网链接：https://unity.com/cn

 </p><p>● 三方SDK名称：Android插件
 </p><p>功能类型：基础功能（AndroidX 核心库、com.android.volley、AndroidSupportLibraryCompat、AndroidSupportLibraryFragment、Android Support Library View pager、android Support.V7、Android Support Library V4、glide图片加载库、Googleguava开发库、android平台事件发布/订阅框架、ReactiveX响应式框架、okhttp网络请求依赖库）、SD卡根目录
 </p><p>第三方主体：Google Inc.
 </p><p>收集/共享方式：调用系统相关接口自动采集
 </p><p>使用目的和场景：app基础功能；app基础功能运行时依赖，仅本地使用
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：位置信息，读取手机状态和身份，查看网络状态、读写外部存储、SD卡根目录、应用安装列表。
 </p><p>隐私政策链接：https://policies.google.cn/privacy
 </p><p>官网链接：https://policies.google.cn/

 </p><p>● 三方SDK名称：Chromium
 </p><p>功能类型：系统工具（org.chromium.ui、org.chromium.android webview、org.chromium.content、org.chromium.device）
 </p><p>第三方主体：Google
 </p><p>收集/共享方式：调用系统相关接口自动采集
 </p><p>使用目的和场景：用于APP内打开与浏览网页，完善基础能力的支撑
 </p><p>权限调用 ：剪切板、获取应用安装列表、传感器（加速度传感器、陀螺仪传感器）
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备网络信息、IP地址。
 </p><p>隐私政策链接：无
 </p><p>官网链接：无

 </p><p>● 联运渠道SDK名称：小米SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：北京瓦力网络科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：为用户提供登录游戏、领取优惠券、参与福利活动以及支付订单功能
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息（Android ID、OAID）、网络信息（网络可用状态、networkCountryIso、wifi的IP地址、SSID、BSSID）、应用信息（应用包名、版本号）、用户身份信息（身份证号、姓名、手机号、证件照片））、游戏ID、传感器信息、应用安装列表、存储权限、运营商信息。
 </p><p>隐私政策链接：https://privacy.mi.com/xiaomigame-sdk/zh_CN/
 </p><p>官网链接：https://trust.mi.com/zh-CN

 </p><p>● 联运渠道SDK名称：Bilibili-SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：上海宽娱数码科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：身份证号（敏感个人信息）、姓名、手机号、设备标识信息（硬件序列号/MAC地址）、应用软件列表。
 </p><p>隐私政策链接：https://www.bilibili.com/blackboard/privacy-h5.html
 </p><p>官网链接：https://www.bilibili.com/

 </p><p>● 联运渠道SDK名称：抖音SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：北京微播视界科技有限公司
 </p><p>收集/共享方式：通过SDK收集（内嵌抖音分享SDK、gbsdk组件、gbsdk.common.host)
 </p><p>使用目的和场景：用于提供账号登录、分享、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：麦克风权限
 </p><p>权限使用目的：使用麦克风权限进行语音转文字
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识符（Android、IMEI/MEID、IMSI、OAID、Android ID、Serial Number、SIM卡信息（ICCID））、MAC地址，IP 地址、位置信息（WLAN接入点、蓝牙）、设备传感器信息、网络信息、设备信息（手机型号/手机厂商/系统版本）、运行中的进程信息；相册权限、存储权限；应用安装列表、SD卡根目录、运营商信息。
 </p><p>隐私政策链接：https://sf1-cdn-tos.douyinstatic.com/obj
 </p><p>官网链接：https://game.open.douyin.com

 </p><p>● 联运渠道SDK名称：九游SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：广州爱九游信息技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（IMEI/IMSI/MAC/OAID）、设备信息（设备型号/操作系统版本/设备设置/移动设备识码/网络设备信息/必要的移动应用列表信息/软硬件及设备/设备环境信息）、设备所在位置信息（IP地址、GPS位置以及能够提供相关信息的WLAN 接入点、基站、传感器信息）。
 </p><p>隐私政策链接：https://open.9game.cn/ngprivacy
 </p><p>官网链接：https://open.9game.cn/

 </p><p>● 联运渠道SDK名称：华为SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：华为软件技术有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（IMEI/硬件设备ID）、设备信息（设备类型、操作系统信息、应用的基本信息）、手机制造商、OAID、SD卡根目录、应用软件列表、手机制造商信息、进程信息（低版本）。
 </p><p>隐私政策链接：https://developer.huawei.com/consumer/cn/policy-center/
 </p><p>官网链接：https://developer.huawei.com/consumer/cn/

 </p><p>● 三方SDK名称：荣耀SDK（荣耀游戏联运SDK）
 </p><p>功能类型：提供账号登录服务，实名认证服务与支付服务
 </p><p>第三方主体：深圳荣耀软件技术有限公司
 </p><p>收集/共享方式：通过SDK采集
 </p><p>使用目的和场景：游戏APP获取用户隐私授权后，调用SDK机型初始化完成账号登陆，游戏内调用SDK完成支付功能
 </p><p>权限调用 ：网络权限/android.permission.INTERNET
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：账号信息（OpenID）、设备信息（设备型号、设备操作系统版本、语言、ROM 版本、国家码（包括通过设备标识符ICCID获取））、应用信息（应用包名、应用版本号、网络类型）、姓名、身份证号码、WiFi信息（含WiFi列表及名称、SSID、BSSID）。
 </p><p>隐私政策链接：https://developer.honor.com/cn/docs/game_center/guides/jieruzhinan/sdkyinsi
 </p><p>官网链接：https://developer.honor.com/cn/

 </p><p>● 三方SDK名称：荣耀广告SDK
 </p><p>功能类型：广告数据监测、上报
 </p><p>第三方主体：深圳荣耀软件技术有限公司
 </p><p>收集/共享方式：通过SDK采集
 </p><p>使用目的和场景：程序化广告投放、广告监测归因、广告防欺诈与运营维护，向最终用户投放广告时使用
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备信息、网络信息、位置信息、应用信息、应用使用信息、上下文信息、广告主服务互动信息、搜索词
 </p><p>隐私政策链接：https://developer.honor.com/cn/docs/20030/guides/sdk-privacy-statement
 </p><p>官网链接：https://developer.honor.com/cn/

 </p><p>● 联运渠道SDK名称：应用宝SDK（腾讯移动应用）
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：深圳市腾讯计算机系统有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：昵称、头像、微信号、QQ号、手机号码、设备标识信息（IMEI/Android_ID/MAC地址/GUID/IMSI/MEID/ICCID）、SSID/BSSID(WIFI的MAC地址)、进程信息（低版本）、设备信息（设备型号/手机品牌/系统版本/运行内存）、SD卡根目录、设备传感器、OAID、应用安装列表、IP地址。
 </p><p>隐私政策链接：https://wikinew.open.qq.com/index.html#/iwiki/1314826296
 </p><p>官网链接：https://app.open.qq.com/p/app/list

 </p><p>● 联运渠道SDK名称：OPPO-SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：广东欢太科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（IMEI/SIM卡序列号/IMSI/Android ID/GAID）、IP地址、读取电话状态、读写存储权限。
 </p><p>隐私政策链接：https://open.oppomobile.com/new/developmentDoc/info?id=11007
 </p><p>官网链接：https://open.oppomobile.com/

 </p><p>● 联运渠道SDK名称：游戏联运SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：OPPO广东移动通信有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（IMEI/SIM卡序列号/IMSI/Android ID/GAID）、IP地址、读取电话状态、读写存储权限。
 </p><p>隐私政策链接：https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0
 </p><p>官网链接：https://brand.heytap.com/

 </p><p>● 联运渠道SDK名称：欢太账号授权SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：OPPO广东移动通信有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（IMEI/SIM卡序列号/IMSI/Android ID/GAID）、账号UID、IP地址、读取电话状态、读写存储权限。
 </p><p>隐私政策链接：https://muc.heytap.com/agreement/privacy-policy/account/auth-sdk/mainland/main/index.html?language=zh-CN
 </p><p>官网链接：https://brand.heytap.com/

 </p><p>● 联运渠道SDK名称：VIVO-SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：广东天宸网络科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：手机imei（Android10以下），手机emmcid、usfid、版本号、Android ID、版本名称 Android10唯一标识符(oaid、vaid、aaid)，其中，Android 10唯一标识符，开发者标识仅适用于安卓10以后版本、应用安装列表。
 </p><p>隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/712
 </p><p>官网链接：https://dev.vivo.com.cn/?from=header

 </p><p>● 联运渠道SDK名称：4399-SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：四三九九网络股份有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：设备标识信息（AndroidID/IMEI/MAC）、IP地址、身份实名信息。
 </p><p>隐私政策链接：https://ptlogin.4399.com/resource/protocol.html
 </p><p>官网链接：https://www.4399.com/

 </p><p>● 联运渠道SDK名称：联想SDK
 </p><p>功能类型：游戏联运服务
 </p><p>第三方主体：北京神奇工场科技有限公司
 </p><p>收集/共享方式：通过SDK收集
 </p><p>使用目的和场景：用于提供账号登录、支付、防沉迷以及实名制游戏联运服务
 </p><p>权限调用 ：不涉及
 </p><p>处理方式：采用去标识化、加密传输的安全处理方式
 </p><p>涉及个人信息类型：身份实名信息、设备标识信息（IMEI/Android ID、MAC地址）。
 </p><p>隐私政策链接：https://hd.lenovomm.com/activity01/privacy/index.html
 </p><p>官网链接：https://open.lenovomm.com/developer/home </p>
  </div>
</template>
<script>

export default {  
};
</script>